<template>
  <el-container v-loading="loading" class="h-full">
    <!--  功能按钮组 start  -->
    <el-header height="42px">
      <slot name="form-options">
        <div class="flex flex-row justify-end align-center">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <template v-for="option in pageData.formOptions">
            <el-button
              v-if="option === 'add'"
              v-show="optionBtnShow(['edit', 'details','copy'])"
              :key="option"
              class="option-btn"
              size="small"
              type="primary"
              @click="infoCreateBtn"
            >新增
            </el-button>
            <el-button
              v-if="option === 'edit'"
              v-show="optionBtnShow(['details'])"
              :key="option"
              class="option-btn"
              size="small"
              type="primary"
              @click="infoUpdateBtn"
            >修改
            </el-button>
            <el-button
              v-if="option === 'copy'"
              v-show="optionBtnShow(['edit', 'details','copy'])"
              :key="option"
              class="option-btn"
              size="small"
              type="primary"
              @click="infoCopyBtn"
            >复制
            </el-button>
            <el-button
              v-if="option === 'details'"
              v-show="optionBtnShow(['edit','copy'])"
              :key="option"
              class="option-btn"
              size="small"
              type="primary"
              @click="infoDetailsBtn"
            >详情
            </el-button>
            <el-button
              v-if="option === 'save'"
              v-show="optionBtnShow(['edit', 'add','copy'])"
              :key="option"
              class="option-btn"
              size="small"
              type="primary"
              @click="infoSaveBtn"
            >
              保存
            </el-button>
            <el-button
              v-if="option === 'cancel'"
              :key="option"
              class="option-btn"
              size="small"
              @click="infoCancelBtn"
            >取消
            </el-button>
          </template>
        </div>
      </slot>
    </el-header>
    <!--  功能按钮组 end  -->
    <!--  表单区 start  -->
    <el-main>
      <el-form
        id="ik-info-head"
        ref="form"
        :disabled="pageData.mode === 'details'"
        :inline="true"
        :model="pageData.formData.head"
        class="ik-info-head"
        label-width="108px"
        size="small"
      >
        <el-row v-for="row in pageData.formItems" :key="row.rowIndex">
          <el-col v-for="col in row.items" :key="col.id" :span="col.span" class="mb-5">
            <form-select-item
              v-if="col.type==='select'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              key-field="key"
              v-bind="col.config"
              value-field="value"
              @onFieldChange="onFieldChange"
            />
            <form-select-item
              v-else-if="col.type==='disselect'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :disabled="col.config.disabled"
              :name="col.name"
              key-field="key"
              v-bind="col.config"
              value-field="value"
              @onFieldChange="onFieldChange"
            />
            <form-label-item
              v-else-if="col.type==='group'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :data-down="loading"
              :name="col.name"
              :url="col.config.url"
              v-bind="col.config"
            />
            <form-date-item
              v-else-if="col.type==='date'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              :url="col.config.url"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-time-item
              v-else-if="col.type==='time'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              :url="col.config.url"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-datetime-item
              v-else-if="col.type==='datetime'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              :url="col.config.url"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-number-item
              v-else-if="col.type==='number'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-image-item
              v-else-if="col.type==='oss'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-image-item
              v-else-if="col.type==='disoss'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :disabled="col.config.disabled"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-file-item
              v-else-if="col.type==='file'"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
            />
            <form-video-item
              v-else-if="col.type==='video'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <form-popup-item
              v-else-if="col.type==='popup'"
              :ref="`popup_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              v-on="col.handleEvent"
            />
            <form-text-item
              v-else-if="col.type==='disText'"
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :disabled="col.config.disabled"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
            <el-form-item
              v-else-if="col.type==='null'"
              :label="col.name"
            />
            <form-text-item
              v-else
              :ref="`input_${col.code}`"
              v-model="pageData.formData.head[col.code]"
              :code="col.code"
              :name="col.name"
              v-bind="col.config"
              @onFieldChange="onFieldChange"
            />
          </el-col>
        </el-row>
      </el-form>
      <slot name="form-bottom" />
    </el-main>
    <!--  表单区 end  -->
  </el-container>
</template>
<script>
import { getById, save, update } from '@/api/ik/data/dataApi'

export default {
  inject: ["pageData"],
  data() {
    return {
      id: "",
      // 页面loading
      loading: false,
      watchIndex: null
    }
  },
  watch: {
    "pageData.mode"(val) {
      if (["edit", "details"].indexOf(val) > -1) {
        this.get(this.pageData.activeId)
      } else {
        if (val === "add") {
          this.pageData.resetFormData()
        }
      }
    },
    watchIndex(newIndex) {
      if (newIndex !== null) {
        this.$watch(
          () => this.pageData.formItems[0].items[newIndex],
          (newVal, oldVal) => {
            console.log(`数组第${newIndex}项变化:`, oldVal, "→", newVal)
          }
        )
      }
    }
  },
  methods: {
    /**
     * 更新表单
     * @param refCode
     */
    handleUpdate(refCode) {
      console.log(`${refCode} updated`)
      this.$refs[refCode].handleSearch()
    },
    /**
     * 获取数据
     * @param id
     */
    get(id) {
      this.loading = true
      getById(this.pageData.bgPath, id)
        .then(res => {
          this.pageData.formData = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 操作按钮是否显示
     * @param modeList
     * @returns {boolean}
     */
    optionBtnShow(modeList) {
      return modeList.indexOf(this.pageData.mode) > -1
    },
    /**
     * 更新表单
     * @param key
     * @param value
     */
    updateFormData(key, value) {
      this.$set(this.pageData.formData.head, key, value)
    },
    // --- 事件 ---
    /**
     * 信息页创建按钮点击
     */
    infoCreateBtn() {
      this.pageData.viewMode = "info"
      this.pageData.mode = "add"
    },
    /**
     * 信息页编辑按钮点击
     */
    infoUpdateBtn() {
      this.pageData.mode = "edit"
    },
    /**
     * 复制按钮点击事件
     */
    infoCopyBtn() {
      // 修改id为控制
      this.pageData.formData.head.id = 0
      this.pageData.activeId = 0
      // 修改为编辑模式
      this.pageData.mode = "copy"
    },
    /**
     * 详情按钮被点击
     */
    infoDetailsBtn() {
      // 修改为编辑模式
      this.pageData.mode = "details"
      this.get(this.pageData.formData.head.id)
    },
    /**
     * 保存按钮点击事件
     */
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    /**
     * 取消按钮点击事件
     */
    infoCancelBtn() {
      this.pageData.viewMode = "list"
      this.pageData.mode = "list"
    },
    /**
     * 字段变更事件
     * @param fieldName
     * @param oldValue
     * @param newValue
     * @param errorSign
     */
    onFieldChange(fieldName, oldValue, newValue, errorSign) {
      this.$set(this.pageData.formData.head, fieldName, newValue)
      // this.$refs.form.validate(valid => {
      //   if (valid) {
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
      // }
      // })
    },
    /**
     * 保存或修改数据
     */
    saveOrUpdate() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const api = [undefined, 0, "0"].indexOf(this.pageData.formData.head.id) > -1 ? save : update
          this.loading = true
          if (this.pageData.useStore) {
            this.pageData.formData.head["storeId"] = this.$store.getters["user/getStoreId"]
            this.pageData.formData.head["storeCode"] = this.$store.getters["user/getStoreCode"]
          }
          api(this.pageData.bgPath, this.pageData.formData).then(res => {
            this.id = res.data
            this.pageData.activeId = res.data
            this.get(res.data)
            this.$message.success("数据已保存")
            this.pageData.mode = 'details'
            this.$emit("success")
          })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    /**
     * 触发特定字段的重新查询
     * @param {String} code - 字段代码
     */
    triggerFieldSearch(code) {
      const refName = `input_${code}`
      if (this.$refs[refName] && this.$refs[refName][0] && this.$refs[refName][0].search) {
        this.$refs[refName][0].search()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
